<template>
  <Filters
    v-if="filters"
    :initialFilter="initialFilter"
    :filterStates="filterStates"
    :customFilterStates="customFilterStates"
    :disabledFilters="defaultFilterTypes"
    :filters="filters"
    @apply="handleApplyFilter"
    @clear="handleClearFilters"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
  </Filters>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { Filters, FilterType } from "@/Components/Filters";
import { useFilters } from "@/Composables/useFilters";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { remove } from "lodash";

const props = defineProps({
  initialFilter: {
    type: String,
    required: false,
  },
  tasksView: {
    type: String,
    required: true,
  },
});

const filterStore = useFilters("tasks");
const { filterStates, customFilterStates, defaultFilterTypes } =
  storeToRefs(filterStore);
const { handleChangeFilter, handleClearFilters } = filterStore;
const { maxSmall } = useBreakpoints();

const filters = ref(null);

const setFilters = () => {
  filters.value = [
    { type: FilterType.STATUS },
    { type: FilterType.LINKED_TO },
    { type: FilterType.ASSIGNED_TO },
    { type: FilterType.DUE_DATE },
    { type: FilterType.PRIORITY },
    { type: FilterType.CATEGORY },
    { type: FilterType.VISIBILITY },
    { type: FilterType.TAGS },
  ];

  if (maxSmall.value || props.tasksView == "kanban") {
    remove(filters.value, (item) => item.type == "status");
  }
};

watch(props, () => {
  setFilters();
});

onMounted(() => {
  setFilters();
});

function handleApplyFilter({ filterType, filterState }) {
  handleChangeFilter(filterType, filterState);
}
</script>
